// @flow
import * as React from 'react';
import { Box, Divider } from 'gestalt';

type Props = {|
  children: React.Node,
  containerWidth: number | string,
  inListView: boolean,
  semiTransparent?: boolean,
|};

const STYLES = {
  semiTransparent: { __style: { opacity: 0.5 } },
};

export default function ProfileBoardCardWrapper({
  children,
  containerWidth,
  inListView,
  semiTransparent,
}: Props) {
  const style = semiTransparent ? STYLES.semiTransparent : undefined;
  return inListView ? (
    <Box justifyContent="center" display="flex" width="100%">
      <Box maxWidth={800} width="100%" paddingX={3}>
        <Divider />
        <Box paddingY={3} width="100%" dangerouslySetInlineStyle={style}>
          {children}
        </Box>
      </Box>
    </Box>
  ) : (
    <Box
      dangerouslySetInlineStyle={style}
      maxWidth={containerWidth}
      overflow="hidden"
      paddingX={3}
      paddingY={5}
    >
      {children}
    </Box>
  );
}
